import { PropsWithChildren } from 'react'

export default function StyledLabel(props: PropsWithChildren): JSX.Element {
  return (
    <label className="uppercase tracking-wide text-gray-600 text-xs font-bold">
      {props.children}
    </label>
  )
}
